import { InputHTMLAttributes } from 'react'
import { Label, SwitchInput, Switch } from './Switch.style'

interface ToggleSwitchProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  adm?: boolean
}

function ToggleSwitch({ adm, label, ...props }: ToggleSwitchProps) {
  return (
    <Label>
      <SwitchInput {...props} type="checkbox" />
      <Switch adm={adm} />
      {label && <span>{label}</span>}
    </Label>
  )
}
export default ToggleSwitch
